<template>
  <div class="login_bg">
    <div class="login_container">
      <div class="login_body">
        <div class="login-form">
          <div class="login-logo">
            <img class="logo" src="../../../assets/images/logo.png" />
            <h2>管理员登录</h2>
          </div>
          <div class="ivu-login">
            <Input
              prefix="ios-contact-outline"
              placeholder="账号"
              style="width: 100%"
              size="large"
              v-model="username"
              clearable
            />
            <Input
              prefix="ios-lock-outline"
              type="password"
              password
              placeholder="密码"
              style="width: 100%"
              v-model="password"
              size="large"
              @on-enter="toLogin"
            />
            <div class="page-account-auto-login">
              <Checkbox v-model="single">记住账号</Checkbox>
            </div>

            <Button
              type="primary"
              long
              size="large"
              @click="toLogin"
              :loading="loading"
              >{{ loginText }}</Button
            >
          </div>

          <p class="copy">
            版权所有 ©
            <a href="http://shop.h234.cn" target="_blank">极客实验室</a>
          </p>
        </div>
        <div class="login-sidebox">
          <div class="login-sidebox__title">
            <h2>Geek-SHOP v3</h2>
            <h4>高性能 / 精致 / 优雅 / 简洁而不简单</h4>
            <p>行业领先的虚拟物品交易商城解决方案。</p>
          </div>
          <img src="../../../assets/images/loginbg.svg" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { Login } from "@/api/admin";
import cookie from "@/utils/store/cookie";
export default {
  data() {
    return {
      username: "",
      password: "",
      loginText: "登录",
      single: false,
      loading: false,
      redirect: "",
    };
  },

  created() {
    if (cookie.getCookie()) {
      this.username = cookie.getCookie().username;
      this.password = cookie.getCookie().password;
      this.single = cookie.get("single");
      if (this.username && this.password) {
        this.$Message.loading({
          content: "您已登录，正在跳转",
          duration: 0,
        });
        this.autoLogin();
      }
    }
    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect;
    }
  },

  methods: {
    // 登录方法
    toLogin() {
      if (!this.username) {
        this.$Message.error({
          background: true,
          content: "账号不能为空",
        });
        return;
      }
      if (!this.password) {
        this.$Message.error({
          background: true,
          content: "密码不能为空",
        });
        return;
      }
      this.loading = true;
      this.loginText = "登录中...";
      Login({
        username: this.username,
        password: this.password,
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.success({
            background: true,
            content: res.msg,
          });
          if (this.single) {
            cookie.setCookie(this.username, this.password, 7);
            cookie.set("single", "true", 30);
          } 
          sessionStorage.setItem("token", res.data);
          if (this.redirect) {
            this.$router.push(this.redirect);
          } else {
            this.$router.push({
              name: "home",
            });
          }
          this.loading = false;
          this.loginText = "登录";
        }else {
          this.$Message.error({
            background: true,
            content: res.msg?res.msg:res.query.msg,
          });
          this.loading = false;
          this.loginText = "登录";
        }
      });
    },

    // 自动登录方法
    autoLogin() {
      Login({
        username: this.username,
        password: this.password,
      }).then((res) => {
        if (res.code == 200) {
          this.$Message.success({
            background: true,
            content: res.msg,
          });
          sessionStorage.setItem("token", res.data);
          if (this.redirect) {
            this.$router.push(this.redirect);
          } else {
            this.$router.push({
              name: "home",
            });
          }
          this.$Message.destroy();
          this.loading = false;
          this.loginText = "登录";
        } else {
          this.$Message.destroy();
          this.$Message.error({
            background: true,
            content: res.msg,
          });
          this.loading = false;
          this.loginText = "登录";
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.login_container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1100px;
  margin: 0 auto;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.login_body {
  border-radius: 20px;
  width: inherit;
  display: flex;
  box-shadow: 0px 20px 80px 0px rgba(0, 0, 0, 0.3);
}

.login-sidebox {
  width: 50%;
  padding: 60px;
  color: #fff;
  background: #3887e5;
  position: relative;
  overflow: hidden;
  border-radius: 0 20px 20px 0;
}

.login-sidebox__title h2 {
  font-size: 30px;
}

.login-sidebox__title h4 {
  font-size: 18px;
  margin-top: 10px;
  font-weight: normal;
}

.login-sidebox__title p {
  font-size: 14px;
  margin-top: 10px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.6);
}

.login-sidebox img {
  position: absolute;
  left: -120px;
  bottom: -160px;
  width: 550px;
}

.login-logo {
  text-align: center;
  margin-bottom: 30px;
}

.login-logo .logo {
  width: 100px;
  margin: 0 auto;
  vertical-align: bottom;
}

.login-logo h2 {
  font-size: 24px;
  margin-top: 20px;
  color: #40485b;
}

.login-title {
  margin-top: 20px;
}

.login-title h2 {
  font-size: 22px;
  font-weight: normal;
}

.login-title p {
  font-size: 12px;
  margin-top: 40px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.8);
}

.login-form {
  width: 50%;
  padding: 60px 100px;
  background: #fff;
  border-radius: 20px 0 0 20px;
}

.ivu-login {
  margin-bottom: 30px;

  .ivu-input-wrapper {
    margin-bottom: 24px;
  }

  .page-account-auto-login {
    margin-bottom: 24px;
    text-align: left;
  }
}

.copy {
  text-align: center;
  color: #999;
}

.login_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-image: url(../../../assets/images/login-bg.jpg);
  background-position: 50%;
  background-size: 100%;
}

@media (max-height: 650px) {
  .login_container {
    position: static;
    transform: none;
    margin: 50px auto;
  }
}

@media (max-width: 1200px) {
  .login_container {
    width: 900px;
  }

  .login-form {
    padding: 60px;
  }
}

@media (max-width: 1000px) {
  .login_container {
    width: 100%;
    background: #fff;
    margin: 0;
    transform: none;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  .login_body {
    box-shadow: none;
  }

  .login-form {
    width: 100%;
    padding: 60px 40px;
  }

  .login-sidebox {
    display: none;
  }

  .login-footer {
    margin-top: 0;
  }
}
</style>